export const verificationFilter = (verifications = [], status) => {
    return verifications.filter(verification => verification.status === status);
};